import styled from "@emotion/styled";

import Tag from "shared/components/Tag";

export const StyledApplicationDataTag = styled(Tag)`
  margin: 0;
  cursor: pointer;
`;
